"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const utils_1 = require("@rjsf/utils");
const clsx_1 = __importDefault(require("clsx"));
const RequiredFieldMarker_1 = __importDefault(require("../../../global/RequiredFieldMarker/RequiredFieldMarker"));
const FieldTemplate = (props) => {
    const { id, classNames, label, displayLabel, help, required, description, errors, children, schema, uiSchema } = props;
    // RJSF by default doesn't render labels for custom types.
    // If we have explicitly defined label visibility in the UI schema take it as preference.
    const showCustomLabel = uiSchema && 'ui:label' in uiSchema;
    const shouldDisplayLabel = showCustomLabel ? Boolean(uiSchema['ui:label']) : displayLabel;
    const schemaType = (0, utils_1.getSchemaType)(schema);
    return (react_1.default.createElement("div", { className: classNames },
        react_1.default.createElement("div", { className: "form-group" },
            shouldDisplayLabel && (react_1.default.createElement("label", { htmlFor: id, className: (0, clsx_1.default)('form-label', showCustomLabel && 'form-label--large'), id: (0, utils_1.titleId)(id) },
                label,
                required ? react_1.default.createElement(RequiredFieldMarker_1.default, { tooltipMessage: "This field is required" }) : null)),
            !shouldDisplayLabel && schemaType === 'array' && (react_1.default.createElement("header", { className: "my-1" },
                react_1.default.createElement("h5", null, label),
                description)),
            !classNames?.includes('array') && !classNames?.includes('object') && description,
            help,
            children,
            errors)));
};
exports.default = FieldTemplate;
